import { jsx, jsxs } from "react/jsx-runtime";
import assert from "assert";
import { useMemo } from "react";
import { normalizeResponsiveValue } from "../../css/atoms/sprinkles.css.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { Box } from "../Box/Box.mjs";
import { Stack } from "../Stack/Stack.mjs";
import { Divider } from "../Divider/Divider.mjs";
import { validTones, AccordionContext } from "./AccordionContext.mjs";
const validSpaceValues = ["medium", "large", "xlarge"];
const defaultSpaceForSize = {
  divided: {
    xsmall: "medium",
    small: "medium",
    medium: "medium",
    standard: "medium",
    large: "large",
    xlarge: "xlarge"
  },
  undivided: {
    xsmall: "large",
    medium: "large",
    small: "large",
    standard: "large",
    large: "large",
    xlarge: "xlarge"
  }
};
const Accordion = ({
  children,
  size = "large",
  tone,
  space: spaceProp,
  dividers = true,
  data,
  ...restProps
}) => {
  assert(
    spaceProp === void 0 || Object.values(normalizeResponsiveValue(spaceProp)).every(
      (value) => value === void 0 || validSpaceValues.includes(value)
    ),
    `To ensure adequate space for touch targets, 'space' prop values must be one of the following: ${validSpaceValues.map((x) => `"${x}"`).join(", ")}`
  );
  assert(
    tone === void 0 || validTones.includes(tone),
    `The 'tone' prop should be one of the following: ${validTones.map((x) => `"${x}"`).join(", ")}`
  );
  const contextValue = useMemo(() => ({ size, tone }), [size, tone]);
  const space = spaceProp ?? defaultSpaceForSize[dividers ? "divided" : "undivided"][size];
  return /* @__PURE__ */ jsx(AccordionContext.Provider, { value: contextValue, children: !dividers ? /* @__PURE__ */ jsx(Stack, { space, data, children }) : /* @__PURE__ */ jsxs(Box, { ...buildDataAttributes({ data, validateRestProps: restProps }), children: [
    /* @__PURE__ */ jsx(Divider, {}),
    /* @__PURE__ */ jsx(Box, { paddingY: space, children: /* @__PURE__ */ jsx(Stack, { space, dividers: true, children }) }),
    /* @__PURE__ */ jsx(Divider, {})
  ] }) });
};
export {
  Accordion,
  validSpaceValues
};
